(() => {
  document.querySelectorAll('.top30-section').forEach(section => {
    const wall = section.querySelector('.wall-scroll');
    const slider = section.querySelector('.wall-position');
    const controls = section.querySelector('.wall-controls');
    if (!wall || !slider || wall.dataset.controlsReady) return;
    wall.dataset.controlsReady = 'true';
    const limit = () => Math.max(0, wall.scrollWidth - wall.clientWidth);
    const sync = () => {
      const max = limit();
      const fraction = max ? wall.scrollLeft / max : 0;
      slider.value = Math.round(fraction * 1000);
      slider.style.setProperty('--wall-progress', `${fraction * 100}%`);
      slider.setAttribute('aria-valuetext', `${Math.round(fraction * 100)}% across the wall`);
      controls.hidden = max < 1;
    };
    slider.addEventListener('input', () => {
      wall.scrollLeft = Number(slider.value) / 1000 * limit();
      sync();
    });
    section.querySelectorAll('[data-wall-direction]').forEach(button => {
      button.addEventListener('click', () => {
        wall.scrollBy({left: Number(button.dataset.wallDirection) * wall.clientWidth * .7, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
    });
    wall.addEventListener('scroll', sync, {passive: true});
    new ResizeObserver(sync).observe(wall);
    sync();
  });
})();
